import React, { useEffect, useRef, useState } from 'react';

interface RevealPointProps {
  emoji: string;
  title: string;
  description: string;
  delayIndex: number;
}

const RevealPoint: React.FC<RevealPointProps> = ({ emoji, title, description, delayIndex }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), delayIndex * 1500);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [delayIndex]);

  return (
    <div
      ref={ref}
      className={`reveal-point ${visible ? 'visible' : ''} flex items-start gap-4 glass-card p-5`}
    >
      <span className="text-3xl flex-shrink-0 mt-1">{emoji}</span>
      <div>
        <h4 className="text-white font-bold text-base mb-1">{title}</h4>
        <p className="text-white/70 text-sm leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default RevealPoint;
